import { useMemo, useRef, useState } from "react"
import './index.scss'
import classnames from "classnames"
import { Col, message, Modal, Row } from "antd"
import { useParams } from 'react-router-dom'
import AvatarsTabContent from "../TalkSkill/components/AvatarsTabContent"
import MakeMessage from "./components/MakeMessage"
import { getTaskInfo, makeMedia } from "@/api"
import { Button } from "antd-mobile"
import TemplateList, { TempType } from "@/components/Common/TemplateList"

function downloadFile(url, type) {
    var aLink = document.createElement('a');
    aLink.download = type === 'video' ? '视频.mp4' : type === 'image' ? '图片.png' : '表情.gif';
    aLink.href = url;
    aLink.click();
}

const tabList = [
    {
        id: -1,
        name: '模板'
    },
    {
        id: 0,
        name: '形象'
    },
    // {
    //     id: 1,
    //     name: '前景'
    // },
    // {
    //     id: 2,
    //     name: '动作'
    // },
    // {
    //     id: 3,
    //     name: '音乐'
    // },
    {
        id: 4,
        name: '文本'
    },
]

const CloudRender = () => {
    let params = useParams();
    const tempType: any = params['*']
    const [activeId, setActiveId] = useState(-1)
    const [liteLoading, setLiteLoading] = useState(false)
    const messageRef = useRef<any>(null)
    const [videoObj, setVideoObj] = useState<any>({})
    const [previewUrl, setPreviewUrl] = useState('')
    const [previewPosterUrl, setPreviewPosterUrl] = useState('')
    const [playStatus, setPlayStatus] = useState(false)
    const [template, setTemplate] = useState<TempType>()
    const [disabledSubmit, setDisabledSubmit] = useState(true)

    const videoRef = useRef<any>()

    const replay = () => {
        videoRef.current.play()
    }
    const pause = () => {
        videoRef.current.pause()
        setPlayStatus(false)
    }
    const onEnded = () => {
        setPlayStatus(false)
    }

    const generate = async (mediaTemp) => {
        setLiteLoading(true)
        const avatar_json = avatarsTabRef.current.selectedAvatar.data
        try {
            mediaTemp.template_options.avatars[0] = {
                text: mediaTemp.template_options.avatars[0].text,
                avatar_json,
            }
            mediaTemp.output = template?.output
            const { taskid } = await makeMedia(mediaTemp, tempType)
            checkoutTaskStatus(taskid)
        } catch (err) {
            console.error(err)
            setLiteLoading(false)
        }
    }

    const checkoutTaskStatus = async (taskid) => {
        const res = await getTaskInfo(
            {
                taskid,
            },
            tempType
        )
        if (res.message === '生成中' || res.message === '排队中') {
            setTimeout(() => {
                checkoutTaskStatus(taskid)
            }, 1000)
        } else {
            if (res.code === 120006) {
                message.error(res.message)
            } else {
                setVideoObj(res)
            }
            setLiteLoading(false)
        }
    }

    const makeHandler = () => {
        if (messageRef.current) {
            if (!templateId) {
                message.error('请选择模板')
            } else {
                messageRef.current.onFinished()
            }
        }
    }

    const downloadMedia = () => {
        downloadFile(videoObj.url, tempType)
    }
    const avatarsTabRef = useRef<any>(null)

    const templateId = useMemo(() => template?.id, [template])

    return (
        <div className="cloud-render-content">
            {
                videoObj.url ? (
                    <>
                        {/* <Button className="preview-btn" onClick={downloadMedia}>保存</Button> */}
                        <Button className="generate-btn" onClick={() => setVideoObj({})}>再次制作</Button>
                    </>
                ) : (
                    <Button disabled={disabledSubmit && tempType === 'video'} className="generate-btn" onClick={makeHandler} >生成</Button>
                )
            }

            <Modal
                open={liteLoading}
                footer={null}
                closable
                onCancel={() => setLiteLoading(false)}
            >
                <div style={{ textAlign: 'center' }}>

                    <p>模版生成中</p>
                    <p>正在生成中，请稍后...</p>
                </div>
            </Modal>

            {
                videoObj.url ? (
                    <div className="media-result">
                        {
                            tempType === 'video' ? (
                                <video
                                    src={videoObj.url}
                                    poster={videoObj.first_frame_url}
                                    controls
                                    style={{ height: '100%' }}
                                ></video>
                            ) : <img src={videoObj.url} alt="" />
                        }
                    </div>
                ) : (
                    <div className='video'>
                        {
                            tempType === 'video' ? (
                                <>
                                    {
                                        !playStatus && (
                                            <img
                                                onClick={replay}
                                                className="playBtn"
                                                src={require('@/assets/slices/btn_play@3x.png')}
                                            />
                                        )
                                    }
                                    <video
                                        ref={videoRef}
                                        src={previewUrl}
                                        poster={previewPosterUrl}
                                        onPause={() => setPlayStatus(false)}
                                        onClick={pause}
                                        onEnded={onEnded}
                                        onPlay={() => setPlayStatus(true)}
                                    >
                                    </video>
                                </>
                            ) : (
                                <img src={previewUrl} alt="" />
                            )
                        }
                    </div>
                )
            }

            <div className="cloud-render-tab" style={{ display: videoObj.url ? 'none' : 'block' }}>
                <div className="facepup-mode-switch" style={{ width: '60%', margin: '0 auto 16px auto' }}>
                    {
                        tabList
                            .filter(i => {
                                if (tempType === 'video') {
                                    return true
                                } else {
                                    return i.id !== 4
                                }
                            })
                            .map(i => (
                                <div
                                    key={i.id}
                                    className={
                                        classnames({
                                            'facepup-mode-switch-item': true,
                                            active: activeId === i.id
                                        })
                                    }
                                    onClick={() => setActiveId(i.id)}
                                >
                                    {i.name}
                                </div>
                            ))
                    }
                </div>
                <div style={{ display: activeId === -1 ? 'block' : 'none' }}>
                    <TemplateList
                        templateId={templateId}
                        setTemplate={setTemplate}
                        setPlayStatus={setPlayStatus}
                        setPreviewUrl={setPreviewUrl}
                        setPreviewPosterUrl={setPreviewPosterUrl}
                    />
                </div>
                <div
                    className="animation-list"
                    style={{
                        height: 'auto',
                        display: activeId === 0 ? 'flex' : 'none',
                        flexWrap: 'wrap'
                    }}
                >
                    <AvatarsTabContent
                        ref={avatarsTabRef}
                    />
                </div>
                <div style={{ display: activeId === 4 ? 'block' : 'none' }}>
                    <MakeMessage
                        disabledSubmit={disabledSubmit}
                        setDisabledSubmit={setDisabledSubmit}
                        avatarsTabRef={avatarsTabRef}
                        templateId={templateId}
                        generate={generate}
                        ref={messageRef}
                    />
                </div>
            </div>
        </div>
    )
}

export default CloudRender
